  import React, { useEffect, useState } from "react";
  import {
    Row,
    Col,
    Table,
    Input,
    message,
    Switch,
    Upload,
    Button,
    Tooltip,
    Radio,
  } from "antd";
  import { PaperClipOutlined } from "@ant-design/icons";
  import SubLayout from "../../components/layout/SubLayout";
  import DeleteIcon from "../../Assets/delete.svg";
  import { DeleteCandidate } from "../../components/common/Popup";
  import { useNavigate } from "react-router-dom";
  import API_MANAGER from "../../API";
  import moment from "moment";
  import EditIcon from "../../Assets/editIcon.svg";
  import CustomPagination from "../../components/common/CustomPagination";
  import SearchListItem from "../../components/common/SearchListItem";

  const filterData = [
    { id: 1, name: "Location", value: "STATE", label: "location" },
    { id: 2, name: "Industry", value: "INDUSTRY", label: "industry" },
    { id: 3, name: "Skills", value: "SKILL", label: "skills" },
    {
      id: 4,
      name: "Qualifications",
      value: "QUALIFICATION",
      label: "qualifications",
    },
    { id: 5, name: "Inductions", value: "INDUCTION", label: "inductions" },
    { id: 6, name: "Medicals", value: "MEDICAL_ASSESSMENT", label: "medicals" },
    { id: 7, name: "Ethnicity", value: "ETHNICITY", label: "ethnicity" },
    { id: 8, name: "Gender", value: "GENDER", label: "gender" },
    {
      id: 9,
      name: "Citizenship",
      value: "CITIZENSHIP",
      label: "citizenship",
      options: [
        {
          label: "Australian",
          value: "YES",
        },
        {
          label: "Non-Australian",
          value: "NO",
        },
      ],
    },
    { id: 10, name: "Visa", value: "VISA", label: "visa" },
  ];

  function CandidateList() {
    const [openDeleteModal, setDeleteModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [deleteId, setDeleteId] = useState(null);
    const [data, setData] = useState([]);
    const navigate = useNavigate();
    const [page, setPage] = useState(() => {
      const savedPage = sessionStorage.getItem("candidateListPage");
      return savedPage ? parseInt(savedPage) : 1;
    });
    const [type, setType] = useState(() => {
      const saved = sessionStorage.getItem("candidateListTabType");
      return saved || "PROFILE";
    });
    const [search, setSearch] = useState(() => {
      const saved = sessionStorage.getItem("candidateListSearch");
      return saved || null;
    });
    const [noProfileData, setNoProfileData] = useState([]);
    const [searcedProfileData, setSearcedProfileData] = useState([]);
    const [filters, setFilters] = useState(() => {
      const saved = sessionStorage.getItem("candidateListFilters");
      return saved ? JSON.parse(saved) : {};
    });
    
    const updateFilters = (newFilters) => {
      setFilters(newFilters);
      sessionStorage.setItem("candidateListFilters", JSON.stringify(newFilters));
    };

    const clearAllFilters = () => {
      setFilters({});
      sessionStorage.setItem("candidateListFilters", JSON.stringify({}));
      setPage(1);
    };

    const hasActiveFilters = () => {
      return Object.keys(filters).length > 0;
    };

    const handleEditFunc = (e, row) => {
      e.stopPropagation();
      sessionStorage.setItem("candidateListTabType", type);
      sessionStorage.setItem("candidateListFilters", JSON.stringify(filters));
      sessionStorage.setItem("candidateListPage", page.toString());
      sessionStorage.setItem("candidateListSearch", search || "");
      navigate(`/candidate-list/candidate-detail/${row?.userId?._id}/edit`, {
        state: {
          data: row,
          path: "/candidate-list",
        },
      });
    };
    const getData = async (search) => {
      setLoading(true);
      const params = {
        page: page,
        search: search ? search : "",
      };
      if (page) {
        try {
          const response = await API_MANAGER.getCandidateList(params);
          setData(response?.data?.data);
          setLoading(false);
        } catch (error) {
          console.log(error);
          message.error("Something went wrong!");
          setLoading(false);
        }
      }
    };
    const deleteConfirm = async () => {
      setConfirmLoading(true);
      try {
        await API_MANAGER.deleteCandidate(deleteId);
        message.success("Candidate successfully deleted.");
        getData(search, 1);
        getDataNoProfile();
      } catch (error) {
        message.error(
          error?.response?.data?.message?.message || "Something went wrong!"
        );
      }
      setConfirmLoading(false);
      setDeleteModal(false);
    };

    const hideUser = async (e, id) => {
      const data = {
        isActive: e,
        isHidden: e,
        isDeleted: false,
        hideReason: "from admin",
      };
      try {
        await API_MANAGER.hideUser(id, data);
        message.success("Candidate updated successfully.");
        getData(search, page);
      } catch (error) {
        message.error("Something went wrong!");
      }
    };
    const hiddenUserAPI = async (e, id) => {
      const data = {
        isHidden: e,
        hideReason: "from admin",
      };
      try {
        await API_MANAGER.hideUser(id, data);
        message.success("Candidate updated successfully.");
        getData(search, page);
      } catch (error) {
        message.error("Something went wrong!");
      }
    };

    const getSearchCandidateList = async () => {
      try {
        setLoading(true);
        const apiParams = { ...filters };
        
        Object.keys(apiParams).forEach((key) => {
          if (Array.isArray(apiParams[key])) {
            if (key === "location") {
              const formattedLocations = apiParams[key].map((location) => {
                if (typeof location === 'string') {
                  const parts = location.split(',').map(part => part.trim());
                  if (parts.length >= 3) {
                    return `${parts[0]}-${parts[1]}-${parts[2]}`;
                  } else if (parts.length === 2) {
                    return `${parts[0]}-${parts[1]}`;
                  }
                  return location;
                }
                return location;
              });
              apiParams[key] = formattedLocations.join(',');
            } else {
              apiParams[key] = apiParams[key].join(',');
            }
          }
        });
        
        const response = await API_MANAGER.searchCandidateProfile({
          ...apiParams,
          page,
          search,
          limit: 10,
        });
        setSearcedProfileData(response?.data?.data);
        setLoading(false);
      } catch (error) {
        message.error("Something went wrong. Please try again.");
        setLoading(false);
      }
    };

    const userType = localStorage.getItem("userType");
    const columns = [
      {
        title: "No.",
        dataIndex: "si",
        width: "80px",
        render: (item, row, index) => {
          return (
            <span className="cursor-pointer">
              {(page - 1) * 10 + (index + 1)}
            </span>
          );
        },
      },
      {
        title: "Name",
        dataIndex: "name",
        render: (text, row) => (
          <span className="cursor-pointer color-primary">{row?.name}</span>
        ),
      },
      {
        title: "Email",
        dataIndex: "email",
        render: (text, row) => (
          <span className="cursor-pointer color-primary">{row?.email}</span>
        ),
      },
      {
        title: "Contact No.",
        dataIndex: "phone",
        render: (text, row) => (
          <span className="cursor-pointer color-primary">
            {"+" + row?.countryCode + "-" + row?.phoneNumber}
          </span>
        ),
      },
      {
        title: (
          <span>
            Profile <br /> Progress
          </span>
        ),
        dataIndex: "profile_progress",
        render: (text, row) => (
          <span className="cursor-pointer color-primary">
            {row?.profileProgress?.overAllProgress
              ? row?.profileProgress?.overAllProgress + "%"
              : "0%"}
          </span>
        ),
      },
      {
        title: "Subscription",
        dataIndex: "subscription",
        render: (text, row) => {
          return (
            <span>
              {row?.subscription[0]?.active ? (
                <span className="Live_text">Active</span>
              ) : (
                <span className="archived_text">Inactive</span>
              )}
            </span>
          );
        },
      },
      {
        title: (
          <span>
            Registration <br /> Date
          </span>
        ),
        dataIndex: "createdAt",
        render: (text, row) => (
          <span className="cursor-pointer color-primary">
            {moment(row.createdAt).format("DD/MM/YYYY")}
          </span>
        ),
      },
      {
        title: (
          <span>
            Last <br /> Login
          </span>
        ),
        dataIndex: "createdAt",
        render: (text, row) => (
          <span className="cursor-pointer color-primary">
            {row?.userId?.lastLogin
              ? moment(row?.userId?.lastLogin).format("DD/MM/YYYY")
              : "-"}
          </span>
        ),
      },
      {
        title: (
          <span>
            Enable / <br /> Disable
          </span>
        ),
        dataIndex: "isActive",
        key: "isActive",
        align: "center",
        render: (_, row) => {
          return (
            <span onClick={(e) => e.stopPropagation()}>
              <Switch
                defaultChecked={row?.userId?.isActive}
                onClick={(e) => hideUser(e, row?.userId?._id)}
              />
            </span>
          );
        },
      },
      {
        title: (
          <span>
            Hide / <br /> Unhide
          </span>
        ),
        dataIndex: "isActive",
        key: "isActive",
        align: "center",
        render: (_, row) => {
          return (
            <span onClick={(e) => e.stopPropagation()}>
              <Switch
                defaultChecked={row?.userId?.isHidden}
                onClick={(e) => hiddenUserAPI(e, row?.userId?._id)}
              />
            </span>
          );
        },
      },
      {
        title: "Action",
        dataIndex: "delete",
        width: "120px",
        align: "center",
        render: (text, row) => (
          <div style={{ display: "flex", justifyContent: "center", gap: "8px" }}>
            <Tooltip title={userType === "admin" ? "" : "Not Authorised"}>
              {userType === "admin" ? (
                <>
                  <img
                    src={EditIcon}
                    alt="edit"
                    style={{ width: "30px", height: "30px" }}
                    className="cursor-pointer"
                    onClick={(e) => {
                      handleEditFunc(e, row);
                    }}
                  />
                  <img
                    src={DeleteIcon}
                    alt="delete"
                    style={{ width: "30px", height: "30px" }}
                    className="cursor-pointer"
                    onClick={(e) => {
                      e.stopPropagation();
                      setDeleteId(row?.userId?._id);
                      setDeleteModal(true);
                    }}
                  />
                </>
              ) : (
                <>
                  <img
                    src={EditIcon}
                    alt="edit"
                    style={{ width: "30px", height: "30px" }}
                    className="cursor-pointer"
                  />
                  <img
                    src={DeleteIcon}
                    alt="delete"
                    style={{ width: "30px", height: "30px" }}
                    className="cursor-pointer"
                  />
                </>
              )}
            </Tooltip>
          </div>
        ),
      },
    ];
    const columns2 = [
      {
        title: "No.",
        dataIndex: "si",
        width: "80px",
        render: (item, row, index) => {
          return (
            <span className="cursor-pointer">
              {(page - 1) * 10 + (index + 1)}
            </span>
          );
        },
      },
      {
        title: "Email",
        dataIndex: "email",
        render: (text, row) => (
          <span className="cursor-pointer color-primary">{row?.email}</span>
        ),
      },
      {
        title: (
          <span>
            Profile <br /> Progress
          </span>
        ),
        dataIndex: "profile_progress",
        render: (text, row) => (
          <span className="cursor-pointer color-primary">
            {row?.profileProgress?.overAllProgress
              ? row?.profileProgress?.overAllProgress + "%"
              : "0%"}
          </span>
        ),
      },
      {
        title: (
          <span>
            Registration <br /> Date
          </span>
        ),
        dataIndex: "createdAt",
        render: (text, row) => (
          <span className="cursor-pointer color-primary">
            {moment(row.createdAt).format("DD/MM/YYYY")}
          </span>
        ),
      },
      {
        title: (
          <span>
            Last <br /> Login
          </span>
        ),
        dataIndex: "createdAt",
        render: (text, row) => (
          <span className="cursor-pointer color-primary">
            {row?.lastLogin ? moment(row?.lastLogin).format("DD/MM/YYYY") : "-"}
          </span>
        ),
      },
      {
        title: "Action",
        dataIndex: "delete",
        width: "80px",
        align: "center",
        render: (text, row) => (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Tooltip title={userType === "admin" ? "" : "Not Authorised"}>
              {userType === "admin" ? (
                <>
                  <img
                    src={DeleteIcon}
                    alt="delete"
                    style={{ width: "30px", height: "30px" }}
                    className="cursor-pointer"
                    onClick={(e) => {
                      e.stopPropagation();
                      setDeleteId(row?._id);
                      setDeleteModal(true);
                    }}
                  />
                </>
              ) : (
                <>
                  <img
                    src={DeleteIcon}
                    alt="delete"
                    style={{ width: "30px", height: "30px" }}
                    className="cursor-pointer"
                  />
                </>
              )}
            </Tooltip>
          </div>
        ),
      },
    ];

    const columns3 = [
      {
        title: "No.",
        dataIndex: "si",
        width: "80px",
        render: (item, row, index) => {
          return (
            <span className="cursor-pointer">
              {(page - 1) * 10 + (index + 1)}
            </span>
          );
        },
      },
      {
        title: "Name",
        dataIndex: "name",
        render: (text, row) => (
          <span className="cursor-pointer color-primary">{row?.name}</span>
        ),
      },
      {
        title: "Email",
        dataIndex: "email",
        render: (text, row) => (
          <span className="cursor-pointer color-primary">{row?.email}</span>
        ),
      },
      {
        title: "Contact No.",
        dataIndex: "phone",
        render: (text, row) => (
          <span className="cursor-pointer color-primary">
            {"+" + row?.countryCode + "-" + row?.phoneNumber}
          </span>
        ),
      },

      {
        title: "Action",
        dataIndex: "delete",
        width: "120px",
        align: "center",
        render: (text, row) => (
          <div style={{ display: "flex", justifyContent: "center", gap: "8px" }}>
            <Tooltip title={userType === "admin" ? "" : "Not Authorised"}>
              {userType === "admin" ? (
                <>
                  <img
                    src={EditIcon}
                    alt="edit"
                    style={{ width: "30px", height: "30px" }}
                    className="cursor-pointer"
                    onClick={(e) => {
                      handleEditFunc(e, row);
                    }}
                  />
                  <img
                    src={DeleteIcon}
                    alt="delete"
                    style={{ width: "30px", height: "30px" }}
                    className="cursor-pointer"
                    onClick={(e) => {
                      e.stopPropagation();
                      setDeleteId(row?.userId?._id);
                      setDeleteModal(true);
                    }}
                  />
                </>
              ) : (
                <>
                  <img
                    src={EditIcon}
                    alt="edit"
                    style={{ width: "30px", height: "30px" }}
                    className="cursor-pointer"
                  />
                  <img
                    src={DeleteIcon}
                    alt="delete"
                    style={{ width: "30px", height: "30px" }}
                    className="cursor-pointer"
                  />
                </>
              )}
            </Tooltip>
          </div>
        ),
      },
    ];
    // const handleChange = ({ fileList: newFileList }) => setFileList(newFileList);
    const handleChange = async (file) => {
      try {
        const data = {
          file: file.fileList?.length > 0 ? file.fileList[0]?.originFileObj : [],
          extension:
            file?.fileList?.length > 0
              ? file?.fileList[0]?.name.split(".")[1]
              : "",
          role: "Candidate",
        };
        const response = await API_MANAGER.bulkUpload(data);
        if (response.data.isSuccess === true)
          message.success(
            `File successfully uploaded, ( uploadedUsers: ${response?.data?.data?.uploadedUsers}, existingUsers: ${response?.data?.data?.existingUsers} ).`
          );
        getData(search, page);
      } catch {
        message.error("Missing required fields");
      }
    };
    const props = {
      name: "file",
      type: "file",
      accept: ".xlsx,.csv,application/msexcel",
      multiple: false,
      customRequest() {
        setTimeout(() => {
          console.log("OK");
        }, 0);
      },
    };
    const getDataNoProfile = async () => {
      const params = {
        search: search ? search : "",
      };
      const response = await API_MANAGER.getCandidateListNoProfile(params);
      setNoProfileData(response?.data?.data);
    };
    const handleChangeExport = async () => {
      const response = await API_MANAGER.getCandidateListNoProfileExport();
      const apiResponseArrayBuffer =
        response?.data; /* Your array buffer data from the API */
      const blob = new Blob([apiResponseArrayBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const blobUrl = URL.createObjectURL(blob);

      const downloadLink = document.createElement("a");
      downloadLink.href = blobUrl;
      downloadLink.download = `Cinchy.me_Candidates_No_profile.xlsx`; // Set the desired file name here
      downloadLink.click();
      URL.revokeObjectURL(blobUrl);
      console.log(response);
    };
    useEffect(() => {
      getData(search);
      getDataNoProfile();
    }, []);
    
    useEffect(() => {
      sessionStorage.setItem("candidateListSearch", search || "");
      getData(search);
      getDataNoProfile();
    }, [search]);
    
    useEffect(() => {
      sessionStorage.setItem("candidateListPage", page.toString());
      getData(search);
    }, [page]);
    
    useEffect(() => {
      sessionStorage.setItem("candidateListTabType", type);
      if (type === "SEARCHPROFILE") {
        getSearchCandidateList();
      } else {
        setSearcedProfileData([]);
      }
    }, [type, search, filters, page]);
    return (
      <SubLayout page="Candidate List">
        <Row>
          <Col>
            {" "}
            <div className="radioButtons2">
              <Radio.Group
                value={type}
                onChange={(e) => {
                  const newType = e?.target?.value;
                  setType(newType);
                  sessionStorage.setItem("candidateListTabType", newType);
                  setPage(1);
                }}
              >
                <Radio.Button value="PROFILE">Profile </Radio.Button>
                <Radio.Button value="NOPROFILE">No Profile</Radio.Button>
                <Radio.Button value="SEARCHPROFILE">Picklist Lookup</Radio.Button>
              </Radio.Group>
            </div>
          </Col>
        </Row>
        <Row
          align={"middle"}
          justify={"space-between"}
          className="search_container"
          gutter={5}
        >
          <Col>
            <div style={{ maxWidth: "254px" }}>
              <Input.Search
                placeholder="Search"
                allowClear
                value={search}
                onChange={(e) => setSearch(e?.target?.value)}
              />
            </div>
          </Col>
          {type === "PROFILE" ? (
            <Col>
              <div style={{ maxWidth: "254px" }}>
                <Upload {...props} showUploadList={false} onChange={handleChange}>
                  <Button className="bulk_button">
                    <span>
                      <PaperClipOutlined />
                      Bulk Candidate Import
                    </span>
                  </Button>
                </Upload>
              </div>
            </Col>
          ) : type === "NOPROFILE" ? (
            <Col>
              <div style={{ maxWidth: "254px" }}>
                <Button className="bulk_button" onClick={handleChangeExport}>
                  <span>
                    <PaperClipOutlined />
                    Export Candidates
                  </span>
                </Button>
              </div>
            </Col>
          ) : (
            <></>
          )}
        </Row>
        {type === "PROFILE" ? (
          <Row className="table_container">
            <Table
              columns={columns}
              dataSource={data?.result}
              pagination={false}
              className="w-100"
              rowKey={"id"}
              loading={loading}
              scroll={{
                y: "calc(100vh - 375px)",
              }}
              onRow={(record) => {
                return {
                  onClick: () => {
                    sessionStorage.setItem("candidateListTabType", type);
                    sessionStorage.setItem("candidateListFilters", JSON.stringify(filters));
                    sessionStorage.setItem("candidateListPage", page.toString());
                    sessionStorage.setItem("candidateListSearch", search || "");
                    navigate(
                      `/candidate-list/candidate-detail/${record?.userId?._id}/view`,
                      {
                        state: {
                          path: "/candidate-list",
                        },
                      }
                    );
                  },
                };
              }}
            />

            <div className="w-100">
              <CustomPagination
                currentPage={page}
                setCurrentPage={setPage}
                total={data?.totalCount}
                itemPerPage={10}
              />
            </div>
          </Row>
        ) : type === "NOPROFILE" ? (
          <Row className="table_container">
            <Table
              columns={columns2}
              dataSource={noProfileData?.result}
              pagination={false}
              className="w-100"
              rowKey={"id"}
              loading={loading}
              scroll={{
                y: "calc(100vh - 375px)",
              }}
            />
          </Row>
        ) : (
          <Row gutter={[16, 16]} className="w-100">
            <Col span={16}>
              <Row className="table_container">
                <Table
                  columns={columns3}
                  dataSource={searcedProfileData?.result}
                  pagination={false}
                  className="w-100"
                  rowKey={"id"}
                  loading={loading}
                  scroll={{
                    y: "calc(100vh - 375px)",
                    x: "600px",
                  }}
                  onRow={(record) => {
                    return {
                      onClick: () => {
                        sessionStorage.setItem("candidateListTabType", type);
                        sessionStorage.setItem("candidateListFilters", JSON.stringify(filters));
                        sessionStorage.setItem("candidateListPage", page.toString());
                        sessionStorage.setItem("candidateListSearch", search || "");
                        navigate(
                          `/candidate-list/candidate-detail/${record?.userId?._id}/view`,
                          {
                            state: {
                              path: "/candidate-list",
                            },
                          }
                        );
                      },
                    };
                  }}
                />

                <div className="w-100">
                  <CustomPagination
                    currentPage={page}
                    setCurrentPage={setPage}
                    total={
                      searcedProfileData?.totalCount ||
                      searcedProfileData?.total ||
                      searcedProfileData?.count ||
                      0
                    }
                    itemPerPage={10}
                  />
                </div>
              </Row>
            </Col>
            <Col xs={0} md={8} className="filter-section">
              <Row className="w-100" justify={"space-between"}>
                <h4 className="h4">Search Profile via Picklist</h4>
              </Row>

              <Row className="w-100" justify={"space-between"} align={"middle"} style={{ marginBottom: "20px" }}>
                <p className="body-text-b2 mb-0">Select filters to apply</p>
                {hasActiveFilters() && (
                  <Button 
                    type="link" 
                    onClick={clearAllFilters}
                    style={{ padding: 0, height: "auto" }}
                  >
                    Clear All
                  </Button>
                )}
              </Row>
              <Col span={24} className="filter-body">
                {filterData.map((item, index) => (
                  <SearchListItem
                    key={index}
                    item={item}
                    filters={filters}
                    setFilters={updateFilters}
                  />
                ))}
              </Col>
            </Col>
          </Row>
        )}
        <DeleteCandidate
          confirmDelete={deleteConfirm}
          visible={openDeleteModal}
          text={"Candidate"}
          setVisible={setDeleteModal}
          loading={confirmLoading}
        />
      </SubLayout>
    );
  }

  export default CandidateList;
